import { IllegalArgumentException } from '../exceptions/illegal-argument.exception';
import { Matcher } from '../matchers/base.matcher';
import { that } from './that.assert';

export function argument<T>(value: T, matcher: Matcher<T>): asserts value is NonNullable<T> {
  that(value, matcher, IllegalArgumentException);
}
